module.exports = __webpack_public_path__ + "img/long-text.3a79bf85.svg";